import {
  emptyPlaceholderKFormFile,
  File as KFormFile,
  jsFileToKFormFile,
  kFormFileToJsFile,
  Schema,
} from "@kform/core";

/**
 * Formats a KForm file {@link value} as a [file list]{@link FileList}, given
 * its {@link schema}.
 * @param value KForm file value to format as a file list.
 * @param schema Schema of the numeric {@link value}.
 * @returns String representation of the numeric {@link value}.
 */
export function formatKFormFileAsFileList<
  T extends KFormFile | null = KFormFile | null,
  // Not using the `schema` is an implementation detail
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>(value: T | undefined, schema: Schema<T>): FileList {
  const dataTransfer = new DataTransfer();
  if (value != null) {
    dataTransfer.items.add(kFormFileToJsFile(value));
  }
  return dataTransfer.files;
}

/**
 * Parses a formatted file list [value]{@link formattedValue} as a KForm file
 * value, given the {@link schema} of the expected KForm file value.
 * @param formattedValue Formatted value to parse as a KForm file value.
 * @param schema Schema of the expected KForm file value.
 * @returns KForm file representation of the
 * [formatted value]{@link formattedValue} according to {@link schema}.
 */
export function parseFileListAsKFormFile<
  T extends KFormFile | null = KFormFile | null,
>(formattedValue: FileList, schema: Schema<T>): T | Promise<T> {
  if (formattedValue.length === 0) {
    return (schema.typeInfo.nullable ? null : emptyPlaceholderKFormFile()) as T;
  }
  return jsFileToKFormFile(formattedValue[0]) as Promise<T>;
}
